// Script to create a new admin user with your real email
// Run this in the browser console on your auth page

import { auth, db } from './firebase';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';

window.createNewAdmin = async (email, password) => {
  try {
    // SECURITY: Only allow specific emails to become admin
    const authorizedAdminEmails = [
      'brona.nilsson@gmail.com',  // Brona's email
      'robbie@ideafarm.se',       // Robbie's email
      // Add more emails as needed
    ];

    if (!authorizedAdminEmails.includes(email)) {
      console.error('❌ Unauthorized: Only specific emails can become admin');
      console.log('Attempted email:', email);
      console.log('Authorized emails:', authorizedAdminEmails);
      return { success: false, error: 'Unauthorized email address' };
    }

    console.log('Creating new admin user with authorized email:', email);
    
    // Create the user
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;
    
    console.log('User created with UID:', user.uid);
    
    // Add user profile to Firestore with admin role
    await setDoc(doc(db, 'users', user.uid), {
      email: email,
      role: 'admin',
      isMember: true,
      membershipDate: new Date(),
      createdAt: new Date()
    });
    
    console.log('✅ New admin user created successfully!');
    console.log('You can now log in with:', email);
    return { success: true, uid: user.uid, email: email };
  } catch (error) {
    console.error('❌ Error creating admin user:', error);
    return { success: false, error: error.message };
  }
};

// Also create a function to delete the old admin@test.com user if needed
window.deleteOldAdmin = async () => {
  try {
    // Note: This requires Firebase Admin SDK or manual deletion from Firebase Console
    console.log('⚠️  To delete the admin@test.com user:');
    console.log('1. Go to Firebase Console > Authentication > Users');
    console.log('2. Find admin@test.com and delete it');
    console.log('3. This will prevent any further password reset emails');
  } catch (error) {
    console.error('Error:', error);
  }
};

console.log('🔧 Admin creation functions loaded!');
console.log('Usage:');
console.log('createNewAdmin("your-real-email@gmail.com", "your-new-password")');
console.log('deleteOldAdmin() - for instructions to delete the old account');
